import { render, staticRenderFns } from "./spReformToMaterial.vue?vue&type=template&id=f5164cd6"
import script from "./spReformToMaterial.vue?vue&type=script&lang=js"
export * from "./spReformToMaterial.vue?vue&type=script&lang=js"
import style0 from "./spReformToMaterial.vue?vue&type=style&index=0&id=f5164cd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports